<template>
  <el-tabs :value="value" @input="$emit('input', $event)" class="page-tabs">
    <slot />
  </el-tabs>
</template>

<script>
export default {
  name: "InterviewerPageTabs",
  props: {
    value: { type: String, default: "" },
  },
};
</script>

<style scoped>
.page-tabs {
  background: #ffffff;
}
.page-tabs ::v-deep .card{
  border: none;
  box-shadow: none; 
}

/* ElementUI el-tabs underline 제거 + 统一字号/内边距 */
.page-tabs ::v-deep .el-tabs__header {
  margin: 0;
  padding-left: 16px;
  border: 1px solid #eee;
}

.page-tabs ::v-deep .el-tabs__nav-wrap::after {
  height: 0;
}

.page-tabs ::v-deep .el-tabs__item {
  font-size: 13px;
  padding: 0 14px;
  color: var(--muted);
  font-weight: 600;
}

.page-tabs ::v-deep .el-tabs__item.is-active {
  color: var(--brand);
}

.page-tabs ::v-deep .el-tabs__active-bar {
  background-color: var(--brand);
}
</style>

